import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "32",
      height: "32",
      fill: "currentColor",
      "fill-opacity": ".18",
      rx: "3"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M25.31 11.522 20.478 6.69a1.5 1.5 0 0 0-1.06-.44h-6.835c-.398.001-.78.16-1.061.44L6.69 11.522c-.28.282-.439.663-.44 1.06v6.835c.001.398.16.78.44 1.061l4.832 4.832c.282.28.663.439 1.06.44h6.835c.398-.001.78-.16 1.061-.44l4.832-4.832c.28-.282.439-.663.44-1.06v-6.835a1.5 1.5 0 0 0-.44-1.061M15.25 11.5a.75.75 0 1 1 1.5 0v5.25a.75.75 0 1 1-1.5 0zm.75 9.75A1.125 1.125 0 1 1 16 19a1.125 1.125 0 0 1 0 2.25"
    }, null, -1)
  ])))
}
export default { render: render }